import Cookies from 'universal-cookie';

const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;
const REST_URL = process.env.REACT_APP_REST_URL;

// Проверка поддержки уведомлений
export function checkNotificationSupport() {
    return 'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window;
}

// Запрос разрешения
export async function requestNotificationPermission() {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
}

export async function getReadyServiceWorker() {
    return await navigator.serviceWorker.ready;
}

// Регистрация service worker
export async function registerServiceWorker() {
    const publicUrl = process.env.PUBLIC_URL || '';
    const swUrl = `${publicUrl}/service-worker.js`;
    const scope = publicUrl || '/';
    return await navigator.serviceWorker.register(swUrl, { scope });
}

// Подписка на push-уведомления
export async function subscribeToPush(swRegistration) {
    const subscription = await swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
    });

    // Отправляем подписку на сервер
    await sendSubscriptionToBackend(subscription);
    return subscription;
}

// Отправка подписки на бэкенд
async function sendSubscriptionToBackend(subscription) {

    const cookies = new Cookies();
    const token = cookies.get('token');

    const response = await fetch(`${REST_URL}/api/notifications/subscribe`, {
        method: 'POST',
        body: JSON.stringify(subscription),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    });

    return response.ok;
}

// Вспомогательная функция для конвертации ключа
function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}